export default theme => ({
  root: {},
  text: {
    fontSize: 13,
    color: theme.colors.utility.textSecondary
  }
});